import { render, staticRenderFns } from "./activeConfigurationAdd.vue?vue&type=template&id=3bc5f21e&scoped=true"
import script from "./activeConfigurationAdd.vue?vue&type=script&lang=js"
export * from "./activeConfigurationAdd.vue?vue&type=script&lang=js"
import style0 from "./activeConfigurationAdd.vue?vue&type=style&index=0&id=3bc5f21e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc5f21e",
  null
  
)

export default component.exports